import { asSvgIcon } from '@lib/common';
import {
  FaGlobeAsia,
  FaHandshake,
  FaScroll,
  FaFilter as FaFilter_,
  FaTrashRestore as _FaTrashRestore,
  FaTrash as _FaTrash,
  FaImdb as _FaImdb,
  FaCheckCircle as _FaCheckCircle,
  FaSourcetree as _FaSourcetree,
  FaNewspaper as _FaNewspaper,
} from 'react-icons/fa';
import { GiTakeMyMoney } from 'react-icons/gi';
import {
  FcGlobe,
  FcSearch as _FcSearch,
  FcComboChart as _FcComboChart,
  FcFinePrint as _FcFinePrint,
  FcPlus as _FcPlus,
  FcWikipedia as _FcWikipedia,
  FcBiotech as _FcBiotech,
} from 'react-icons/fc';
import { BiGitMerge, BiDuplicate as _BiDuplicate, BiEdit as _BiEdit } from 'react-icons/bi';
import {
  AiOutlineNumber,
  AiOutlineInfoCircle as _AiOutlineInfoCircle,
  AiOutlinePlusCircle as _AiOutlinePlusCircle,
  AiOutlineMinusCircle as _AiOutlineMinusCircle,
  AiFillMinusCircle as _AiFillMinusCircle,
  AiOutlineShrink as _AiOutlineShrink,
} from 'react-icons/ai';
import { IoIosTrash } from 'react-icons/io';
import { IoTrailSign as _IoTrailSign } from 'react-icons/io5';
import {
  BsFillInboxesFill as _BsFillInboxesFill,
  BsFillQuestionDiamondFill as _BsFillQuestionDiamondFill,
  BsBook as _BsBook,
  BsLayoutSidebarInsetReverse as _BsLayoutSidebarInsetReverse,
  BsFillPeopleFill as _BsFillPeopleFill,
} from 'react-icons/bs';

import { VscMultipleWindows as _VscMultipleWindows } from 'react-icons/vsc';
import {
  RiRecycleFill as _RiRecycleFill,
  RiSearchFill as _RiSearchFill,
  RiEraserFill as _RiEraserFill,
} from 'react-icons/ri';
import { TiFlowMerge as _TiFlowMerge, TiNews as _TiNews } from 'react-icons/ti';
import { HiLogout as _HiLogout, HiPlusCircle as _HiPlusCircle } from 'react-icons/hi';
import { BsPencilSquare as _BsPencilSquare } from 'react-icons/bs';
import { IoIosCreate as _IoIosCreate } from 'react-icons/io';
import {
  GiArtificialHive as _GiArtificialHive,
  GiArchiveResearch as _GiArchiveResearch,
} from 'react-icons/gi';
import { SiMicrosoftexcel as _SiMicrosoftexcel, SiLinkedin as _SiLinkedin } from 'react-icons/si';
import { MdKeyboard as _MdKeyboard, MdCheckCircle as _MdCheckCircle } from 'react-icons/md';
import {
  MdLocationOn as _MdLocationOn,
  MdPublic as _MdPublic,
  MdDelete as _MdDelete,
  MdRestore as _MdRestore,
  MdDescription as _MdDescription,
} from 'react-icons/md';
import { RiGitRepositoryPrivateLine as _RiGitRepositoryPrivateLine } from 'react-icons/ri';
import { TiTick as _TiTick } from 'react-icons/ti';
import { ImCrop as _ImCrop, ImDrawer2 as _ImDrawer2 } from 'react-icons/im';
import { BsFillGearFill as _BsFillGearFill } from 'react-icons/bs';
import { BiSend as _BiSend } from 'react-icons/bi';

import {
  AiFillCheckCircle as _AiFillCheckCircle,
  AiFillStop as _AiFillStop,
  AiOutlineCheckCircle as _AiOutlineCheckCircle,
  AiFillPlusCircle as _AiFillPlusCircle,
  AiOutlineExpandAlt as _AiOutlineExpandAlt,
} from 'react-icons/ai';

import { RiDraftFill as _RiDraftFill } from 'react-icons/ri';
import { GrClone as _GrClone, GrResources as _GrResources } from 'react-icons/gr';
import { MdMergeType as _MdMergeType } from 'react-icons/md';

export const GrClone = asSvgIcon(_GrClone);
export const HandShakeIcon = asSvgIcon(FaHandshake);
export const TakeMyMoneyIcon = asSvgIcon(GiTakeMyMoney);
export const GlobeIconFc = asSvgIcon(FcGlobe);
export const GlobeAsiaIcon = asSvgIcon(FaGlobeAsia);
export const GitMergeIcon = asSvgIcon(BiGitMerge);
export const OutlineNumber = asSvgIcon(AiOutlineNumber);
export const TrashFill = asSvgIcon(IoIosTrash);
export const ScrollIcon = asSvgIcon(FaScroll);
export const FaFilter = asSvgIcon(FaFilter_);
export const BsFillInboxesFill = asSvgIcon(_BsFillInboxesFill);
export const VscMultipleWindows = asSvgIcon(_VscMultipleWindows);
export const BiDuplicate = asSvgIcon(_BiDuplicate);
export const RiRecycleFill = asSvgIcon(_RiRecycleFill);
export const IoTrailSign = asSvgIcon(_IoTrailSign);
export const FaTrashRestore = asSvgIcon(_FaTrashRestore);
export const FaTrash = asSvgIcon(_FaTrash);
export const BiEdit = asSvgIcon(_BiEdit);
export const TiFlowMerge = asSvgIcon(_TiFlowMerge);
export const FcSearch = asSvgIcon(_FcSearch);
export const RiSearchFill = asSvgIcon(_RiSearchFill);
export const FcFinePrint = asSvgIcon(_FcFinePrint);
export const FcComboChart = asSvgIcon(_FcComboChart);
export const BsFillQuestionDiamondFill = asSvgIcon(_BsFillQuestionDiamondFill);
export const HiLogout = asSvgIcon(_HiLogout);
export const RiEraserFill = asSvgIcon(_RiEraserFill);
export const AiOutlineInfoCircle = asSvgIcon(_AiOutlineInfoCircle);
export const BsPencilSquare = asSvgIcon(_BsPencilSquare);
export const IoIosCreate = asSvgIcon(_IoIosCreate);
export const AiOutlinePlusCircle = asSvgIcon(_AiOutlinePlusCircle);
export const AiOutlineMinusCircle = asSvgIcon(_AiOutlineMinusCircle);
export const GiArtificialHive = asSvgIcon(_GiArtificialHive);
export const SiMicrosoftexcel = asSvgIcon(_SiMicrosoftexcel);
export const MdKeyboard = asSvgIcon(_MdKeyboard);
export const FcPlus = asSvgIcon(_FcPlus);
export const TiNews = asSvgIcon(_TiNews);
export const GiArchiveResearch = asSvgIcon(_GiArchiveResearch);
export const MdLocationOn = asSvgIcon(_MdLocationOn);
export const MdPublic = asSvgIcon(_MdPublic);
export const RiGitRepositoryPrivateLine = asSvgIcon(_RiGitRepositoryPrivateLine);
export const MdDelete = asSvgIcon(_MdDelete);
export const TiTick = asSvgIcon(_TiTick);
export const MdRestore = asSvgIcon(_MdRestore);
export const ImCrop = asSvgIcon(_ImCrop);
export const ImDrawer2 = asSvgIcon(_ImDrawer2);
export const FaImdb = asSvgIcon(_FaImdb);
export const SiLinkedin = asSvgIcon(_SiLinkedin);
export const FcWikipedia = asSvgIcon(_FcWikipedia);
export const BsFillGearFill = asSvgIcon(_BsFillGearFill);
export const AiFillCheckCircle = asSvgIcon(_AiFillCheckCircle);
export const AiFillStop = asSvgIcon(_AiFillStop);
export const AiOutlineCheckCircle = asSvgIcon(_AiOutlineCheckCircle);
export const FaCheckCircle = asSvgIcon(_FaCheckCircle);

export const MdCheckCircle = asSvgIcon(_MdCheckCircle);
export const BiSend = asSvgIcon(_BiSend);
export const RiDraftFill = asSvgIcon(_RiDraftFill);
export const AiFillPlusCircle = asSvgIcon(_AiFillPlusCircle);
export const HiPlusCircle = asSvgIcon(_HiPlusCircle);
export const AiFillMinusCircle = asSvgIcon(_AiFillMinusCircle);
export const FcBiotech = asSvgIcon(_FcBiotech);
export const GrResources = asSvgIcon(_GrResources);
export const FaSourcetree = asSvgIcon(_FaSourcetree);

export const BsBook = asSvgIcon(_BsBook);
export const FaNewspaper = asSvgIcon(_FaNewspaper);
export const BsLayoutSidebarInsetReverse = asSvgIcon(_BsLayoutSidebarInsetReverse);
export const AiOutlineExpandAlt = asSvgIcon(_AiOutlineExpandAlt);
export const AiOutlineShrink = asSvgIcon(_AiOutlineShrink);
export const MdMergeType = asSvgIcon(_MdMergeType);
export const BsFillPeopleFill = asSvgIcon(_BsFillPeopleFill);
export const MdDescription = asSvgIcon(_MdDescription);
